import { lazy } from 'react';

export { default as Article } from './ArticleDocument';
export { default as Contest } from './ArticleDocument';
export { default as Video } from './EpisodeOrVideoDocument';
export { default as Podcast } from './EpisodeOrVideoDocument';
export { default as Interactive } from './InteractiveDocument';
export { default as Newsletter } from './NewsletterDocument';
export const ArticleLegacy = lazy(
    () => import(/* webpackChunkName: "document_article_legacy" */ './ArticleLegacyDocument'),
);
// export { default as Micromag } from './MicromagDocument';
export const Micromag = lazy(
    () => import(/* webpackChunkName: "document_micromag" */ './MicromagDocument'),
);
export const Survey = lazy(
    () => import(/* webpackChunkName: "document_survey" */ './SurveyDocument'),
);
